import useAuth from "../../../hooks/useAuth";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import "./GridHeader.css";
import { useEffect, useState } from "react";

interface GridHeaderProps {
    concertId: number;
    concertVersion: number;
    concertLocation: string;
    startDate: Date;
    currentEvent: any;
}

const GridHeader = ({ concertId, currentEvent }: { concertId: number, currentEvent: any }) => {
    const axiosPrivate = useAxiosPrivate();

    const [concertData, setConcertData] = useState<GridHeaderProps>({
        concertId,
        concertVersion: 0,
        concertLocation: "",
        startDate: new Date(),
        currentEvent: null,
    });

    const [currentDateTime, setCurrentDateTime] = useState<Date>(new Date());

    useEffect(() => {
        const fetchConcertData = async () => {
            try {
                const response = await axiosPrivate.get(
                    `concerts/${concertId}`
                );
                const concertDateResponse = response.data[0];
                console.log(concertDateResponse);
                if (response.data && response.status === 200) {
                    setConcertData({
                        concertId,
                        concertVersion: concertDateResponse.wersja,
                        concertLocation: concertDateResponse.miejsceKoncertu,
                        startDate: new Date(concertDateResponse.dataKoncertu),
                        currentEvent,
                    });
                } else {
                    throw new Error("Network response failed");
                }
            } catch (error) {
                console.error("Error fetching concert data:", error);
            }
        };

        fetchConcertData();

        const intervalId = setInterval(() => {
            setCurrentDateTime(new Date());
        }, 1000);

        return () => clearInterval(intervalId);
    }, [concertId]);

    return (
        <div className="grid-header">
            <div className="concert-id">{concertData.concertLocation}</div>
            <div className="current-concert">
                Aktualnie gra: {currentEvent ? currentEvent.tytul : ""}
            </div>
            <div className="concert-start">
                Start: {concertData.startDate?.getHours()}:
                {concertData.startDate?.getMinutes() >= 10
                    ? concertData.startDate.getMinutes()
                    : `0${concertData.startDate.getMinutes()}`}
            </div>
            <div className="current-time">
            Aktualna data: {currentDateTime.toLocaleDateString('pl-PL', { day: '2-digit', month: '2-digit', year: 'numeric' })}{" "}
            {currentDateTime.toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })}
            </div>
        </div>
    );
};

export default GridHeader;
